export const DocumentAttachements = [
  "MD, DO, DPM, NP or PA Home Healthcare signed/verbal order (required)",
  "Supporting Clinical Documentation (required)",
];

export const ApplicableDocuments = [
  "H&P",
  "Inpatient Discharge Summary",
  "Notes from Hospital or SNF (including any therapy notes)",
  "MD Office Notes",
  "Wound Care Notes with Measurements",
];

export enum DocumentUploadActionDispatchTypes {
  DOCUMENT_UPLOAD_RESET = "DOCUMENT_UPLOAD_RESET",
  DOCUMENT_UPLOAD_INVOKE = "DOCUMENT_UPLOAD_INVOKE",
  DOCUMENT_UPLOAD_SUCCESS = "DOCUMENT_UPLOAD_SUCCESS",
}

export enum DocumentDeleteActionDispatchTypes {
  DOCUMENT_DELETE_RESET = "DOCUMENT_DELETE_RESET",
  DOCUMENT_DELETE_INVOKE = "DOCUMENT_DELETE_INVOKE",
  DOCUMENT_DELETE_SUCCESS = "DOCUMENT_DELETE_SUCCESS",
}

export enum DocumentType {
  PDF = "pdf",
  DOC = "msword",
  DOCX = "vnd.openxmlformats-officedocument.wordprocessingml.document",
  PNG = "png",
  JPEG = "jpeg",
  JPG = "jpg",
  INVALID = "",
}
